import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Grid, TextField, FormControl, InputLabel, Select, MenuItem,
    CircularProgress, Box
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { CreateTerminalSchema } from '../schemes/CreiacaoDeTerminais';

export default function ModalNovaMaquina({ open, onClose, onSave, isLoading }) {

    const [formData, setFormData] = useState({
        nm_maquina: '',
        operador: '',
        ativo: 'S',
    });


    const [erroNomeMaquina, setErroNomeMaquina] = useState(false);
    const [erroNomeMaquinaMsg, setErroNomeMaquinaMsg] = useState("");


    useEffect(() => {
        if (open) {
            setFormData({
                nm_maquina: '',
                operador: '',
                ativo: 'S',
            });
            setErroNomeMaquina(false);
            setErroNomeMaquinaMsg('');
        }
    }, [open]);

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let nm_maquina = formData.nm_maquina;
        let cod_maquina = '1234'; // Valor fixo para validação
        const result = CreateTerminalSchema.safeParse({ nm_maquina, cod_maquina });

        if (!result.success) {
            const errors = result.error.format();

            if (errors.nm_maquina?._errors?.length) {
                setErroNomeMaquina(true);
                setErroNomeMaquinaMsg(errors.nm_maquina._errors[0]);
            } else {
                setErroNomeMaquina(false);
                setErroNomeMaquinaMsg('');
            }

            console.log("Erros de validação:", errors);

            return;
        }

        onSave(formData);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Criar Máquina</DialogTitle>
            <Box component="form" onSubmit={handleSubmit}>
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                fullWidth
                                required
                                autoComplete="off"
                                label="Nome da Máquina"
                                name="nm_maquina"
                                value={formData.nm_maquina}
                                onChange={handleChange}
                                error={erroNomeMaquina}
                                helperText={erroNomeMaquinaMsg}
                                InputProps={{
                                    sx: { backgroundColor: 'white', color: 'black' }
                                }}
                                InputLabelProps={{
                                    sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                                }}
                                FormHelperTextProps={{
                                    sx: { fontSize: '0.9rem', color: 'red', fontWeight: 'bold' }
                                }}
                            />
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                required
                                select
                                fullWidth
                                name="operador"
                                value={formData.operador}
                                onChange={handleChange}
                                label="Operador"
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                            >
                                <MenuItem value="stone">Stone</MenuItem>
                                <MenuItem value="cielo">Cielo</MenuItem>
                                <MenuItem value="getnet">Get Net</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                required
                                select
                                fullWidth
                                name="ativo"
                                value={formData.ativo}
                                onChange={handleChange}
                                label="Status"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                            >
                                <MenuItem value="S">Ativo</MenuItem>
                                <MenuItem value="N">Inativo</MenuItem>
                                <MenuItem value="M">Manutenção</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="secondary">Cancelar</Button>
                    <Button
                        type="submit"
                        variant="outlined"
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />} disabled={isLoading}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}